import { FiberManualRecord } from '@mui/icons-material';
import { Checkbox, Chip, Grid, styled, TableCell, TableRow } from '@mui/material';
import { colors } from '../constants';
import { Typography } from '@totalsoft/rocket-ui';

export const PaymentPlanTableCell = styled(TableCell)(({ theme }) => ({
  textAlign: 'center',
  paddingBlock: theme.spacing(0.5),
  paddingInline: theme.spacing(1),
  '& .MuiFormControlLabel-root': {
    margin: 0
  }
}));

export const PaymentPlanTableRow = styled(TableRow, { shouldForwardProp: prop => !['invoiced'].includes(prop) })(({ invoiced }) => ({
  backgroundColor: invoiced && '#A3DCFB'
}));

export const CalendarYearTableCell = styled(PaymentPlanTableCell)(({ theme }) => ({
  position: 'sticky',
  left: 0,
  background: theme.palette.white.main,
  borderRight: '1px solid lightgrey',
  zIndex: 2
}));

export const ClickableText = styled(Typography)(() => ({
  '&:hover': {
    cursor: 'pointer',
    textDecoration: 'underline'
  }
}));

export const CalendarTableCell = styled(PaymentPlanTableCell)(({ theme }) => ({
  padding: `${theme.spacing(1.5)} ${theme.spacing(0.5)} ${theme.spacing(1)} ${theme.spacing(0.5)}`,
  borderRight: '1px solid lightgrey',
  height: theme.spacing(11),
  minHeight: theme.spacing(11),
  maxHeight: theme.spacing(11)
}));

export const CalendarCheckbox = styled(Checkbox)(() => ({
  margin: 0,
  padding: 0
}));

export const ColoredCircle = styled(FiberManualRecord, { shouldForwardProp: prop => !['colorIndex'].includes(prop) })(
  ({ theme, colorIndex }) => ({
    fontSize: theme.spacing(2),
    color: colors[colorIndex]
  })
);

export const CalendarTableCellChip = styled(Chip)(({ theme }) => ({
  width: '100%',
  height: theme.spacing(2.5),
  fontSize: theme.spacing(1.5),
  borderRadius: theme.spacing(0.5)
}));

export const CalendarOptionsWarning = styled(Grid)(({ theme }) => ({
  background: theme.palette.warning.main,
  color: theme.palette.white.main,
  borderRadius: theme.spacing(1)
}));

export const CalendarOptionRow = styled(Grid)(({ theme }) => ({
  border: '1px solid lightgrey',
  borderRadius: theme.spacing(1)
}));

export const NoCalendarOptionsContainer = styled(Grid)(({ theme }) => ({
  border: '2px dashed grey',
  borderRadius: theme.spacing(1)
}));
